import { render, staticRenderFns } from "./ReferencerenView.vue?vue&type=template&id=2cb0e409&scoped=true"
import script from "./ReferencerenView.vue?vue&type=script&lang=js"
export * from "./ReferencerenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0e409",
  null
  
)

export default component.exports